export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";